import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88a36a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey-6 text-caption q-px-md q-pt-xs" }, " AI-generated content may be incorrect. ", -1))
const _hoisted_3 = { class: "label-sidebar__scroll-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "row justify-center q-pa-md"
}
const _hoisted_5 = {
  key: 1,
  class: "text-grey text-center q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelFilterSidebarHeader = _resolveComponent("LabelFilterSidebarHeader")!
  const _component_SelectedLabelChips = _resolveComponent("SelectedLabelChips")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_LabelCategoryGroup = _resolveComponent("LabelCategoryGroup")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LabelFilterSidebarHeader, {
      ref: "header",
      searching: _ctx.searching,
      keyword: _ctx.keyword,
      onSearch: _ctx.onKeywordChange,
      onOpenSearch: _ctx.openSearch,
      onCloseSearch: _ctx.closeSearch,
      onClose: _ctx.close
    }, null, 8, ["searching", "keyword", "onSearch", "onOpenSearch", "onCloseSearch", "onClose"]),
    _hoisted_2,
    (_ctx.hasSelection)
      ? (_openBlock(), _createBlock(_component_SelectedLabelChips, {
          key: 0,
          labels: _ctx.selectedLabels,
          categories: _ctx.selectedCategories,
          onRemove: _ctx.toggle,
          onRemoveCategory: _ctx.toggleCategory,
          onClear: _ctx.clearSelection
        }, null, 8, ["labels", "categories", "onRemove", "onRemoveCategory", "onClear"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading && !_ctx.labels.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_spinner, { size: "sm" })
          ]))
        : (!_ctx.labels.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.keyword ? 'No matches' : 'No insights available'), 1))
          : (_ctx.groupedByCategory.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.groupedByCategory, (group) => {
                return (_openBlock(), _createBlock(_component_LabelCategoryGroup, {
                  key: group.name || '__uncategorized',
                  group: group,
                  selection: _ctx.selection,
                  onToggle: _ctx.toggle,
                  onToggleCategory: _ctx.toggleCategory
                }, null, 8, ["group", "selection", "onToggle", "onToggleCategory"]))
              }), 128))
            : _createCommentVNode("", true),
      _createVNode(_component_InfiniteScroll, {
        active: _ctx.hasMore,
        loading: _ctx.loadingMore,
        onLoadMore: _ctx.loadMore
      }, null, 8, ["active", "loading", "onLoadMore"])
    ])
  ]))
}